import CustomConfirm from "@/components/common/confirm";
import CustomToast from "@/components/common/toast";
import "@/helpers/debounceMixin";
import "@/helpers/filters";
import HttpErrorMessageHandler from "@/helpers/httpErrorMessageHandler";
import "@/helpers/mixin";
import VueCompositionAPI from "@vue/composition-api";
import BootstrapVue from "bootstrap-vue";
import vco from "v-click-outside";
import VueMask from "v-mask";
import Vue from "vue";
import VueConfirmDialog from "vue-confirm-dialog";
import VueRouter from "vue-router";
import Scrollspy from "vue2-scrollspy";
import Vuelidate from "vuelidate";
import router from "./router/index";

import "./configuration/axios";

import "@/assets/design/iconoir.css";
import "@/assets/design/index.scss";

import store from "@/store/store";

import App from "./App.vue";

import i18n from "@/modules/localization/i18n";

import { Client } from "@modules/websocket";
import "@modules/websocket/websocket-client-handler";

Vue.config.errorHandler = (error, vm, info) => {
  try {
    console.error(error);
    if (error.message || error.stack) {
      Client.sendMessage({ meta: { type: "ClientApplicationError", url: window.location.href }, data: { error: error.message, stack: error.stack, info } });
    }
  } catch (err) {
    console.error(err);
  }
};

//

import FlowyPlugin from "@hipsjs/flowy-vue";
import "@hipsjs/flowy-vue/dist/lib/flowy-vue.css";

import GraphBlock from "@/components/common/graph/graph-block";
import GraphNode from "@/components/common/graph/graph-node";

Vue.component("graph-block", GraphBlock);
Vue.component("graph-node", GraphNode);
Vue.use(FlowyPlugin);

//-> register common components
import ContentLoading from "@c/content-loading";
import Empty from "@c/empty";
import FilterSelect from "@c/form/filter-select";
import LetterAvatar from "@c/form/letter-avatar.vue";
import SweetButton from "@c/form/sweet-button";
import SweetInput from "@c/form/sweet-input";
import Product from "@c/product";
import RightPanel from "@c/right-panel";
import SortableTableHead from "@c/table/sortable-table-head";
import TaskAvatar from "@cc/task/task-avatar";
import TaskDetail from "@cc/task/task-detail";
import TaskItem from "@cc/task/task-item";
import TaskPriority from "@cc/task/task-priority";
import TaskRelationBadge from "@cc/task/task-relation-badge";
import TaskStatus from "@cc/task/task-status";
import TaskStatusSelect from "@cc/task/task-status-select";
import Multiselect from "vue-multiselect";

Vue.component("empty", Empty);
Vue.component("content-loading", ContentLoading);
Vue.component("letter-avatar", LetterAvatar);
Vue.component("filter-select", FilterSelect);
Vue.component("sweet-button", SweetButton);
Vue.component("sweet-input", SweetInput);
Vue.component("right-panel", RightPanel);
Vue.component("sortable-table-head", SortableTableHead);
Vue.component("task-detail", TaskDetail);
Vue.component("task-status-select", TaskStatusSelect);
Vue.component("task-status", TaskStatus);
Vue.component("task-item", TaskItem);
Vue.component("task-relation-badge", TaskRelationBadge);
Vue.component("task-priority", TaskPriority);
Vue.component("product", Product);
Vue.component("task-avatar", TaskAvatar);
Vue.component("multiselect", Multiselect);
//<--

Vue.config.productionTip = false;

Vue.use(VueCompositionAPI);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
Vue.use(require("vue-scrollto"));
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueConfirmDialog);
Vue.use(CustomConfirm);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.use(CustomToast);
Vue.use(HttpErrorMessageHandler);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
